<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست سطوح اساتید</h1>
          <b-row>
            <!-- Search -->
            <b-col cols="12">
              <div
                class="d-flex flex-column flex-md-row align-items-center justify-content-end"
              >
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="جستجوی عنوان"
                  label-for="searchCommand"
                >
                  <b-form-input
                    id="searchCommand"
                    v-model="mastersLevelsFilter.title"
                    class="d-inline-block"
                    placeholder="برنز..."
                    @keydown.enter="setPageNumberAndGetAllMasterLevels"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="ساعت شروع"
                  label-for="fromHour"
                >
                  <b-form-input
                    id="fromHour"
                    v-model="mastersLevelsFilter.fromHour"
                    placeholder="4"
                    @keydown.enter="setPageNumberAndGetAllMasterLevels"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="ساعت پایان"
                  label-for="toHour"
                >
                  <b-form-input
                    id="toHour"
                    v-model="mastersLevelsFilter.toHour"
                    class="d-inline-block"
                    placeholder="4"
                    @keydown.enter="setPageNumberAndGetAllMasterLevels"
                  />
                </b-form-group>
                <b-form-group
                  class="d-inline-block w-100"
                  label="قیمت شخصی سازی شده"
                  label-for="canUseCustomePrice"
                >
                  <!-- canUseCustomePrice -->
                  <b-form-select
                    id="canUseCustomePrice"
                    v-model="mastersLevelsFilter.canUseCustomePrice"
                    :options="canUseCustomePriceStatuses"
                  ></b-form-select>
                </b-form-group>
                <b-button
                  variant="primary"
                  class="ml-1 mb-2 mb-md-0"
                  @click="setPageNumberAndGetAllMasterLevels"
                >
                  اعمال
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="mastersLevelsList"
                responsive
                :fields="myTableColumns"
                primary-key="id"
                show-empty
                bordered
                striped
                empty-text="موردی موجود نیست!"
              >
                <template #cell(canUseCustomePrice)="data">
                  <b-badge
                    class="font-weight-normal"
                    :variant="
                      data.item.canUseCustomePrice ? 'success' : 'danger'
                    "
                  >
                    {{ data.item.canUseCustomePrice ? "بله" : "خیر" }}
                  </b-badge>
                </template>
                <template #cell(fromHour)="data">
                  از {{ data.item.fromHour }} ساعت
                </template>
                <template #cell(toHour)="data">
                  تا {{ data.item.toHour }} ساعت
                </template>
                <template #cell(weekWaitCount)="data">
                  {{ data.item.weekWaitCount ? data.item.weekWaitCount : "-" }}
                  <span v-if="data.item.weekWaitCount">هفته</span>
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex align-items-center">
                    <b-link
                      :to="`/apps/masters-levels/${data.item.id}`"
                      class="mr-2"
                    >
                      <feather-icon
                        class="text-primary"
                        icon="EditIcon"
                        size="20"
                      />
                    </b-link>
                    <div
                      style="cursor: pointer"
                      @click="renderDeleteConfirmation(data.item)"
                      v-b-modal.modal-delete
                    >
                      <feather-icon
                        class="text-danger"
                        icon="Trash2Icon"
                        size="20"
                      />
                    </div>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                v-model="mastersLevelsFilter.pageNumber"
                :total-rows="totalCount"
                :per-page="mastersLevelsFilter.count"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف سطح استاد"
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteAMasterLevel"
    >
      <b-container>
        <span v-if="tempLevel">
          آیا از حذف کردن سطح {{ tempLevel.title }} از
          {{ tempLevel.fromHour }}
          ساعت تا {{ tempLevel.toHour }} ساعت اطمینان دارید؟
        </span>
      </b-container>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getAllMasterLevels();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllMasterLevels();
      },
    },
  },
  data() {
    return {
      mastersLevelsFilter: {
        title: null,
        fromHour: null,
        toHour: null,
        canUseCustomePrice: null,
        pageNumber: 1,
        count: 10,
      },
      mastersLevelsList: null,
      totalCount: null,
      isLoading: false,
      tempLevel: null,
      myTableColumns: [
        {
          key: "id",
          label: "شناسه سطح",
        },
        {
          key: "title",
          label: "عنوان سطح",
        },
        {
          key: "fromHour",
          label: "از چند ساعت در هفته",
        },
        {
          key: "toHour",
          label: "تا چند ساعت در هفته",
        },
        {
          key: "weekWaitCount",
          label: "تعداد هفته مورد نیاز در این سطح تا رسیدن به سطح بعدی",
        },
        {
          key: "canUseCustomePrice",
          label: "قیمت شخصی سازی شده دارد",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      canUseCustomePriceStatuses: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "قیمت شخصی سازی شده",
        },
        {
          value: false,
          text: "قیمت معمولی",
        },
      ],
    };
  },
  methods: {
    setPageNumberAndGetAllMasterLevels() {
      this.mastersLevelsFilter.pageNumber = 1;
      this.getAllMasterLevels();
    },
    async deleteAMasterLevel() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAMasterLevel = new DeleteAMasterLevel(_this);
        deleteAMasterLevel.setRequestParam({ id: _this.tempLevel.id });
        await deleteAMasterLevel.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "Trash2Icon",
                variant: "success",
                text: "سطح با موفقیت حذف شد.",
              },
            });
            _this.getAllMasterLevels();
            _this.tempLevel = null;
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderDeleteConfirmation(level) {
      this.tempLevel = JSON.parse(JSON.stringify(level));
    },
    createGetAllPayloadWithFilters() {
      // Check for filters
      // Sorry for this part :|
      // This is hidious
      let payload = {
        count: this.mastersLevelsFilter.count,
        pageNumber: this.mastersLevelsFilter.pageNumber,
      };
      if (this.mastersLevelsFilter.title) {
        payload["title"] = this.mastersLevelsFilter.title;
      }
      if (this.mastersLevelsFilter.fromHour) {
        payload["fromHour"] = this.mastersLevelsFilter.fromHour;
      }
      if (this.mastersLevelsFilter.toHour) {
        payload["toHour"] = this.mastersLevelsFilter.toHour;
      }
      if (this.mastersLevelsFilter.canUseCustomePrice) {
        payload["canUseCustomePrice"] =
          this.mastersLevelsFilter.canUseCustomePrice;
      }
      return payload;
    },
    async getAllMasterLevels() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllMasterLevels = new GetAllMasterLevels(_this);
        getAllMasterLevels.setRequestParamDataObj(
          _this.createGetAllPayloadWithFilters()
        );
        await getAllMasterLevels.fetch((res) => {
          _this.mastersLevelsList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.mastersLevelsFilter.pageNumber;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
  },
};
import {
  GetAllMasterLevels,
  DeleteAMasterLevel,
} from "@/libs/Api/ScheduleMasterRegular";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
</script>
